// This file was automatically generated from print.referralOrder.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.referralOrder');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.data.physicians');
goog.require('el8.template.fax.letter');
goog.require('el8.template.print');
goog.require('el8.template.print.letter.attachments');
goog.require('el8.template.print.order');
goog.require('el8.template.print');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.referralOrder.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak"><div class="printOrderInfo">');
  el8.template.print.header(opt_data, output);
  el8.template.print.headerInfoOrders(soy.$$augmentData(opt_data, {title: 'Referral'}), output);
  output.append('<div class="el8ReferralOrderPrintContainer"><div><table class="w100"><tr><td class="w23 normalText el8Bold">Consultant:</td><td class="largeText el8Bold">', (opt_data.order.consultantName) ? soy.$$escapeHtml(opt_data.order.consultantName) : (opt_data.displayTo) ? soy.$$escapeHtml(opt_data.displayTo) : 'n/a');
  if (opt_data.order.physician && opt_data.order.physician.specialties && opt_data.order.physician.specialties.length) {
    output.append('<span class="normalText ml5">(');
    el8.template.data.physicians.specialtyList(opt_data.order.physician, output);
    output.append(')</span>');
  }
  output.append('</td></tr>', (opt_data.order.physician) ? ((opt_data.order.physician.phone) ? '<tr><td class="w23 normalText pt5">Phone:</td><td>' + soy.$$escapeHtml(opt_data.order.physician.phone) + '</td></tr>' : '') + ((opt_data.order.physician.fax) ? '<tr><td class="w23 normalText pt5">Fax Number:</td><td>' + soy.$$escapeHtml(opt_data.order.physician.fax) + '</td></tr>' : '') + ((opt_data.order.physician.fullAddress) ? '<tr><td class="w23 normalText pt5">Address:</td><td>' + soy.$$escapeHtml(opt_data.order.physician.fullAddress) + '</td></tr>' : '') : '', '</table></div><table class="w100">', (opt_data.order.signDate) ? '<tr><td class="w23 normalText pt5">Date of Referral:</td><td>' + (soy.$$escapeHtml(opt_data.order.signDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.order.signDate)) : '') + '</td></tr>' : '', '<tr><td class="w23 normalText el8Bold pt10">Reason for Referral:</td><td class="preserve pb10 el8Bold">', soy.$$escapeHtml(opt_data.order.clinicalReason), '</td></tr><tr><td class="w23 normalText pt5">Authorization For:</td><td class="preserve">', soy.$$escapeHtml(opt_data.order.authorizationFor), '</td></tr>', (opt_data.order.authNumber) ? '<tr><td class="w23 normalText pt5">Referral Authorization #:</td><td class="preserve">' + soy.$$escapeHtml(opt_data.order.authNumber) + '</td></tr>' : '', '<tr><td class="w23 normalText pt5">Dxs:</td><td class="preserve">');
  el8.template.print.order.dxsSectionTwoLines(opt_data, output);
  output.append('</td></tr></table></div><div class="el8ReferraleSig">');
  if (opt_data.signDate) {
    if (opt_data.isReferralLetter) {
      if (opt_data.signUserBehalfName) {
        el8.template.print.sentBy({signUserName: opt_data.signUserName, signUserBehalfName: opt_data.signUserBehalfName, signDate: opt_data.signDate, localFsPath: opt_data.localFsPath, esignatureUrl: opt_data.order.esignatureUrl}, output);
      } else {
        el8.template.print.signature({esignatureUrl: opt_data.order.esignatureUrl, localFsPath: opt_data.localFsPath, signPhysicianName: opt_data.signUserName, signDate: opt_data.signDate}, output);
      }
    } else {
      el8.template.print.signature({esignatureUrl: opt_data.order.esignatureUrl, isOrder: true, localFsPath: opt_data.localFsPath, signPhysician: opt_data.order.signPhysician, signPhysicianIdentifiers: opt_data.order.signPhysicianIdentifiers, signDate: opt_data.order.signDate}, output);
    }
  }
  output.append('</div>');
  if (opt_data.passportUrl) {
    el8.template.fax.letter.passportCta(opt_data, output);
  } else {
    el8.template.print.letter.attachments.tableOfContents(opt_data, output);
  }
  output.append('</div></div>');
  if (!opt_sb) return output.toString();
};
